/**
 * Περικοπή κειμένου **σε λέξεις**, όχι σε χαρακτήρες.
 *
 * Χρησιμοποιείται από τις κάρτες —συλλογής και καθηκόντος— που δείχνουν την αρχή
 * μιας περιγραφής. Ζει εδώ και όχι μέσα σε καθεμία, γιατί είναι ο **ίδιος**
 * κανόνας με διαφορετικό όριο: δύο αντίγραφα θα απέκλιναν στη μεταχείριση των
 * κενών, και η απόκλιση θα φαινόταν ως «η μία κάρτα κόβει αλλιώς από την άλλη».
 *
 * ⚠ **ΓΙΑΤΙ ΛΕΞΕΙΣ ΚΑΙ ΟΧΙ ΧΑΡΑΚΤΗΡΕΣ.** Η περικοπή σε χαρακτήρες κόβει **μέσα
 * στη λέξη**, και στα ελληνικά αυτό παράγει συχνά άλλη λέξη — «χρηματοδότ…»,
 * «προϋπολογι…». Η περικοπή σε λέξεις δίνει πάντοτε ολόκληρες λέξεις, με τίμημα
 * ότι το **οπτικό** μήκος δεν είναι σταθερό· εκείνο το ρυθμίζει η διάταξη, με
 * ορισμένο ύψος και `line-clamp`.
 *
 * Το `…` **μπαίνει μόνο όταν κόπηκε κάτι**: αποσιωπητικά σε πλήρες κείμενο λένε
 * ψέματα, και ο χρήστης ψάχνει τη συνέχεια που δεν υπάρχει.
 */
export function firstWords(text, limit) {
    const clean = String(text ?? '').trim();
    if (clean === '') return '';

    // ⚠ **ΚΟΒΕΙ ΤΟ ΠΡΩΤΟΤΥΠΟ, ΔΕΝ ΞΑΝΑΣΥΝΘΕΤΕΙ ΑΠΟ ΛΕΞΕΙΣ.**
    //
    // Η προφανής υλοποίηση —χωρισμός σε λέξεις και ένωση με κενό—
    // **κανονικοποιεί τα κενά**, δηλαδή ισοπεδώνει τις αλλαγές γραμμής. Το
    // αποτέλεσμα ήταν ασυνεπές με τρόπο που κανείς δεν θα υποψιαζόταν: η
    // **κομμένη** περιγραφή έχανε τις παραγράφους της και η **πλήρης** τις
    // κρατούσε, οπότε η ίδια κάρτα άλλαζε μορφή ανάλογα με το μήκος του
    // κειμένου της.
    //
    // Εδώ μετρώνται οι λέξεις πάνω στο πρωτότυπο και κόβεται **η
    // συμβολοσειρά**, οπότε ό,τι επιβιώνει είναι αυτούσιο.
    const words = [...clean.matchAll(/\S+/g)];
    if (words.length <= limit) return clean;

    const last = words[limit - 1];
    return `${clean.slice(0, last.index + last[0].length)}…`;
}

export default firstWords;
